// extracted by mini-css-extract-plugin
export default {"product":"Style_product__mjudU"};